import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const Login = () => {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <div className="copyright text-center text-xl-left text-muted">
                © {new Date().getFullYear()}{" "}
                <a
                  className=" text-light font-weight-bold ml-1"
                  href="#"
                 // target="_blank"
                >
                  Dodo-Shop Team
                </a>
              </div>
            </Col>
            <Col xl="6">
              <Nav className="nav-footer justify-content-center justify-content-xl-end ">
                <NavItem>
                  <NavLink
                      href="#"
                      className=" text-light font-weight-bold ml-1"
                    //target="_blank"
                  >
                    Dodo-Shop  Team
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className=" text-light font-weight-bold ml-1"
                    //target="_blank"
                  >
                    About Us
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                      href="#"
                      className=" text-light font-weight-bold ml-1"
                   // target="_blank"
                  >
                    Blog
                  </NavLink>
                </NavItem>
                {/*<NavItem>*/}
                {/*  <NavLink*/}
                {/*    href="https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md?ref=adr-auth-footer"*/}
                {/*    //target="_blank"*/}
                {/*  >*/}
                {/*    MIT License*/}
                {/*  </NavLink>*/}
                {/*</NavItem>*/}
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
